var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var GoogleDriveIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '22' : _b, _c = _a.height, height = _c === void 0 ? '19' : _c;
    return (_jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 22 19", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", className: "inline-block" }, { children: _jsx("path", { d: "M6.7099 1.5L0.149902 13L3.5799 19L10.1299 7.5M8.7299 13L5.2999 19H18.4199L21.8499 13M21.2799 12L14.4199 0H7.5799H7.5699L14.4299 12H21.2799Z" }) })));
};
export default GoogleDriveIcon;
